import React, { useState } from "react";
import { useSelector } from "react-redux";
import axios from "http-axios";

// components (global)
import ButtonProgress from "components/ButtonProgress";

// firebase
import { useFirebase } from "react-redux-firebase";

// form
import { useForm } from "react-hook-form";

// helpers
import { deviceValidate } from "helpers/validation/deviceValidate";

// material-ui
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// styles
const useStyles = makeStyles((theme) => ({
  root: {},
}));

const AddDeviceDialog = () => {
  const classes = useStyles();
  const firebase = useFirebase();
  const { errors, handleSubmit, register } = useForm();

  // state
  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [master, setMaster] = useState(false);

  // selector
  const uid = useSelector((state) => state.firebase.auth.uid);
  const selectedPropertyId = useSelector(
    (state) => state.main.selectedProperty
  );
  const selectedVendor = useSelector((state) => state.main.selectedVendor);

  // functions
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (!submitting) setOpen(false);
  };

  const handleOnChange = (event) => {
    setMaster(event.target.checked);
  };

  const onSubmit = ({ email, password, name, master }) => {
    if (!submitting) {
      setSubmitting(true);

      firebase
        .auth()
        .currentUser.getIdToken()
        .then((token) => {
          const headers = {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          };

          const data = {
            uid: uid,
            email: email,
            password: password,
            name: name,
            master: master,
            property_id: selectedPropertyId,
            vendor_id: selectedVendor,
          };

          axios
            .post(`jagaCardCreateDeviceAccount`, data, {
              headers: headers,
            })
            .then((res) => {
              if (res.data.result === "success") {
                setSubmitting(false);
                handleClose();
                // if (
                //   res.data.duplicated_cards &&
                //   res.data.duplicated_cards.length > 0
                // ) {
                //   setError("cardNumber", "duplicate");
                // }
                // if (res.data.new_cards && res.data.new_cards.length > 0) {
                //   handleClose();
                // }
              } else if (res.data.result === "error") {
                console.log(res.data.message)
              }
            })
            .catch((e) => {
              console.log(e.message);
              setSubmitting(false);
            });
        });
    }
  };

  return (
    <div>
      <Button variant="contained" color="primary" onClick={handleClickOpen}>
        add device
      </Button>

      <form
        noValidate
        xs={12}
        onSubmit={handleSubmit(onSubmit)}
        autoComplete="off"
      >
        <Dialog
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          onClose={handleClose}
          open={open}
          fullWidth={true}
          maxWidth="md"
          scroll="paper"
        >
          <DialogTitle id="alert-dialog-title" className={classes.modalTitle}>
            <div>
              <Typography
                className={classes.modalTitle}
                variant="h3"
                component="h2"
              >
                Add Device
              </Typography>
            </div>
          </DialogTitle>

          <DialogContent dividers>
            <Grid
              container
              spacing={2}
              direction="row"
              justify="center"
              alignItems="flex-start"
            >
              <Grid item md={6}>
                <TextField
                  fullWidth
                  size="small"
                  id="email"
                  name="email"
                  label="Email *"
                  type="text"
                  variant="outlined"
                  autoComplete="off"
                  inputRef={register(deviceValidate.email.rules)}
                  helperText={
                    errors.email &&
                    deviceValidate.email.message[errors.email.type]
                  }
                  error={!!errors.email}
                />
              </Grid>
              <Grid item md={6}>
                <TextField
                  fullWidth
                  size="small"
                  id="name"
                  name="name"
                  label="Name *"
                  type="text"
                  variant="outlined"
                  autoComplete="off"
                  inputRef={register(deviceValidate.name.rules)}
                  helperText={
                    errors.name && deviceValidate.name.message[errors.name.type]
                  }
                  error={!!errors.name}
                />
              </Grid>
              <Grid item md={6}>
                <TextField
                  fullWidth
                  size="small"
                  id="password"
                  name="password"
                  label="Password *"
                  type="password"
                  variant="outlined"
                  autoComplete="off"
                  inputRef={register(deviceValidate.password.rules)}
                  helperText={
                    errors.password &&
                    deviceValidate.password.message[errors.password.type]
                  }
                  error={!!errors.password}
                />
              </Grid>
              <Grid item md={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="master"
                      checked={master}
                      onChange={handleOnChange}
                      color="primary"
                      inputRef={register}
                    />
                  }
                  label="Master Device"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={handleClose}>
              Cancel
            </Button>
            <ButtonProgress
              type="submit"
              containName="Save"
              margin={false}
              loading={submitting}
              disabled={submitting}
              onClick={handleSubmit(onSubmit)}
            />
          </DialogActions>
        </Dialog>
      </form>
    </div>
  );
};

export default AddDeviceDialog;
